module.exports = __webpack_public_path__ + "static/media/downarrow.c2925d07.svg";